<template>
  <div class="web-header">
    <a class="web-logo" :href="'https://wetv.vip/' + curLang">
      <!-- eslint-disable-next-line max-len -->
      <svg data-theme="light" width="124px" height="32px" viewBox="0 0 124 32"><defs><filter filterUnits="userSpaceOnUse" x="5.5" y="0" width="30" height="32"><feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix></filter></defs><mask maskUnits="userSpaceOnUse" x="5.5" y="0" width="30" height="32"><path d="M6.6 3.5C5.9 7.6 5.5 11.7 5.5 16c0 4.3.4 8.4 1.1 12.5.4 2.1 2.2 3.5 4.2 3.5.5 0 .9-.1 1.4-.2 3.9-1.4 7.8-3.2 11.5-5.4 3.7-2.1 7.3-4.3 10.1-7.2 2.3-2.4 2-4.6 0-6.5-3-2.8-6.6-5.1-10.3-7.2C19.8 3.4 16 1.6 12.1.3c-.4-.2-.8-.3-1.3-.3-2 0-3.8 1.4-4.2 3.5" fill="#fff" filter="url(#a)"></path></mask><linearGradient id="c" gradientUnits="userSpaceOnUse" x1="-83.802" y1="36.956" x2="-83.531" y2="36.044" gradientTransform="matrix(30.0212 0 0 -32 2530.308 1181)"><stop offset="0" stop-color="#57caff"></stop><stop offset="1" stop-color="#0083f4"></stop></linearGradient><path d="M6.6 3.5C5.9 7.6 5.5 11.7 5.5 16c0 4.3.4 8.4 1.1 12.5.4 2.1 2.2 3.5 4.2 3.5.5 0 .9-.1 1.4-.2 3.9-1.4 7.8-3.2 11.5-5.4 3.7-2.1 7.3-4.3 10.1-7.2 2.3-2.4 2-4.6 0-6.5-3-2.8-6.6-5.1-10.3-7.2C19.8 3.4 16 1.6 12.1.3c-.4-.2-.8-.3-1.3-.3-2 0-3.8 1.4-4.2 3.5" mask="url(#b)" fill="url(#c)"></path><defs><filter id="d" filterUnits="userSpaceOnUse" x="0" y="2.7" width="6.6" height="25.2"><feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix></filter></defs><mask maskUnits="userSpaceOnUse" x="0" y="2.7" width="6.6" height="25.2" id="e"><path d="M1.1 5.5C.1 8.2 0 11.2 0 14.1V15.3c0 3.3 0 6.7 1.1 9.8 1 2.8 2.9 3.2 5.2 2.5.1 0 .2-.1.3-.1-.7-4-1.1-8-1.1-12.2 0-4.2.4-8.3 1.1-12.3h-.3c-.5-.2-1-.2-1.5-.2-1.7-.1-3 .8-3.7 2.7" fill="#fff" filter="url(#d)"></path></mask><linearGradient id="f" gradientUnits="userSpaceOnUse" x1="-73.243" y1="36.096" x2="-73.252" y2="36.824" gradientTransform="matrix(6.566 0 0 -25.2324 484.242 933.316)"><stop offset="0" stop-color="#ff7004"></stop><stop offset="1" stop-color="#ffba00"></stop></linearGradient><path d="M1.1 5.5C.1 8.2 0 11.2 0 14.1V15.3c0 3.3 0 6.7 1.1 9.8 1 2.8 2.9 3.2 5.2 2.5.1 0 .2-.1.3-.1-.7-4-1.1-8-1.1-12.2 0-4.2.4-8.3 1.1-12.3h-.3c-.5-.2-1-.2-1.5-.2-1.7-.1-3 .8-3.7 2.7" mask="url(#e)" fill="url(#f)"></path><defs><filter id="g" filterUnits="userSpaceOnUse" x="5.5" y="3.1" width="22.3" height="24.5"><feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"></feColorMatrix></filter></defs><mask maskUnits="userSpaceOnUse" x="5.5" y="3.1" width="22.3" height="24.5" id="h"><path d="M5.5 15.4c0 4.2.4 8.3 1.1 12.2 3.5-1.1 7-2.5 10.4-4.1 3.4-1.7 6.6-3.4 9.4-5.7 2.1-1.6 1.9-3.6 0-5.1-2.8-2.2-6.1-4-9.5-5.7-3.3-1.6-6.7-2.9-10.2-4-.9 4.1-1.2 8.2-1.2 12.4" fill="#fff" filter="url(#g)"></path></mask><linearGradient id="i" gradientUnits="userSpaceOnUse" x1="-82.862" y1="35.843" x2="-82.501" y2="36.825" gradientTransform="matrix(22.3112 0 0 -24.5133 1859.535 907.07)"><stop offset="0" stop-color="#60ba08"></stop><stop offset="1" stop-color="#b5ff24"></stop></linearGradient><path d="M5.5 15.4c0 4.2.4 8.3 1.1 12.2 3.5-1.1 7-2.5 10.4-4.1 3.4-1.7 6.6-3.4 9.4-5.7 2.1-1.6 1.9-3.6 0-5.1-2.8-2.2-6.1-4-9.5-5.7-3.3-1.6-6.7-2.9-10.2-4-.9 4.1-1.2 8.2-1.2 12.4" mask="url(#h)" fill="url(#i)"></path><path d="M10 10.3s-.2.5-.2 5 .2 5.1.2 5.1c.1.6.4.7 1 .6 0 0 1-.2 5.1-2.2 4.1-2.1 4.8-2.8 4.8-2.8.4-.4.6-.7 0-1.2 0 0-1.1-1-4.8-2.9C12.5 10 11 9.7 11 9.7c-.1 0-.2-.1-.3-.1-.4 0-.6.2-.7.7M45.4 6.9h3c.5 0 .9.4.9.8l1.3 12.2h.1l5.8-12.5c.2-.3.5-.5.8-.5h2.8c.4 0 .8.3.9.8l2.2 12.6h.1l5-12.8c.1-.3.5-.6.9-.6h2.5c.7 0 1.1.7.8 1.3l-8 18.4c-.1.3-.5.6-.8.6h-2.6c-.4 0-.8-.3-.9-.8l-2.4-13.3h-.1l-6.2 13.5c-.1.3-.5.5-.8.5h-2.5c-.4 0-.8-.3-.9-.8L44.5 8c-.1-.6.4-1.1.9-1.1zm36.1 11.8c.1-.7 0-1.3-.5-1.9-.4-.5-1-.8-1.8-.8-.5 0-.9.1-1.3.2-.4.2-.7.3-1 .6-.3.2-.5.5-.7.8-.2.3-.3.6-.4 1h5.7zm2 5.4c.4.4.4 1 0 1.4-.6.5-1.3.9-2.1 1.3-1.1.5-2.2.7-3.4.7-1.1 0-2.1-.2-2.9-.5-.9-.3-1.6-.8-2.2-1.5-.6-.6-1-1.4-1.3-2.3-.3-.9-.3-1.9-.2-3 .2-1.1.5-2.1 1-3 .5-.9 1.2-1.7 2-2.3.8-.6 1.7-1.1 2.7-1.5 1-.3 2-.5 3.1-.5 1 0 1.9.2 2.6.5.8.3 1.4.8 1.9 1.5 1.3 1.8 1.3 4.1.9 6.2-.1.3-.3.4-.5.4h-9.5c.1.8.3 1.5.8 2s1.2.7 2 .7c.7 0 1.3-.2 1.8-.5.3-.2.6-.4.9-.7.3-.3.8-.3 1.2 0l1.2 1.1zm9.3-13.2h-4.7c-.6 0-1-.5-.9-1l.3-2.1c.1-.5.4-.8.9-.8h14.2c.6 0 1 .5.9 1l-.3 2.1c-.1.5-.4.8-.9.8h-5l-2.2 15.5c-.1.5-.4.8-.9.8h-2.6c-.6 0-1-.5-.9-1l2.1-15.3zm12.7-4h3.2c.4 0 .8.3.9.7l3 12.6h.1l6.7-12.8c.2-.3.5-.5.8-.5h2.7c.7 0 1.1.7.8 1.4l-10.2 18.4c-.2.3-.5.5-.8.5h-2.3c-.4 0-.8-.3-.9-.7l-4.8-18.4c-.2-.6.2-1.2.8-1.2z" fill="#fff"></path></svg>
    </a>

    <div class="lang-switch" @mouseover="showLangPop" @mouseout="hideLangPop">
      <div class="current-lang">{{ curLang && curLang.toUpperCase() || 'EN' }}</div>
      <div class="dropdown-wrapper" v-if="langPopVisible">
        <div class="dropdown">
          <div class="lang-item" v-for="lang in languages"
            :key="lang.value"
            :class="{ selected: lang.value === curLang }"
            @click="changeLang(lang)">
            {{ lang.label }}
          </div>
        </div>
      </div>
    </div>

    <div class="user-avatar">
      <Avatar class="avatar" :src="avatar" @click="onLogin" :defaultAvatar="'https://vip.image.video.qpic.cn/vupload/20230529/743b7e1685351520890.png'" />
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

import Avatar from '@tencent/vft-ui/src/Avatar/Avatar.vue';
import login from '@tencent/wetv-common/login';

import { getLang, getSupportLangs, saveLang } from 'src/util/lang';

export default {
  components: {
    Avatar,
  },
  data() {
    return {
      curLang: getLang(),
      languages: getSupportLangs(),
      langPopVisible: false,
    };
  },
  computed: {
    avatar() {
      return this.$store.state.avatar;
    },
  },
  methods: {
    ...mapActions(['clearUserInfo']),
    changeLang(lang) {
      saveLang(lang.value);
      window.location.reload();
    },
    showLangPop() {
      this.hideLangPopTimeout && clearTimeout(this.hideLangPopTimeout);
      this.langPopVisible = true;
    },
    hideLangPop() {
      this.hideLangPopTimeout = setTimeout(() => {
        this.langPopVisible = false;
      }, 200);
    },
    async onLogin() {
      if (login.isLogin()) {
        this.confirm({
          msg: this.$lang[38] || '是否确定退出登录？',
          confirmText: this.$lang[39] || 'Confirm',
          cancelText: this.$lang[36],
          confirm: () => {
            login.logout();
            this.clearUserInfo();
          },
        });
      } else {
        login.openLogin();
      }
    },
  },
};
</script>
<style lang="scss">
.web-header {
  display: flex;
  align-items: center;
  height: 80px;
  margin: 0 90px;
  .lang-switch {
    margin-left: auto;
    margin-right: 20px;
    position: relative;
    .current-lang {
      border-radius: 4px;
      border: 2px solid #fff !important;
      font-size: 12px;
      text-align: center;
      height: 26px;
      line-height: 22px;
      min-width: 26px;
    }
    .dropdown-wrapper {
      position: absolute;
      top: 32px;
      left: -50px;
      .dropdown {
        background: #fff !important;
        box-shadow: 0 8px 36px 0 rgba(0,0,0,.2);
        border-radius: 4px;
        padding: 12px 26px;
        color: #071139;
      }
      .lang-item {
        margin: 8px 0;
        cursor: pointer;
        font-size: 14px;
        position: relative;
        line-height: 20px;
        white-space: nowrap;
        &.selected {
          color: #ff4a22;
          &::before {
            content: " ";
            display: block;
            position: absolute;
            left: -12px;
            top: 50%;
            margin-top: -2px;
            width: 4px;
            height: 4px;
            background: #ff4a22;
            border-radius: 50%;
          }
        }
      }
    }

  }
  .user-avatar .avatar {
    width: 34px;
    height: 34px;
  }
}
</style>
